<script>
import * as _ from 'lodash'
export default {
  model: {
    event: 'update',
  },
  props: {
    questionId: { type: Number, required: true },
    questionTitle: { type: String, required: true },
    questionOptions: { type: Object, required: true },
    questionType: { type: String, required: true },
    selected: { type: null, required: true },
  },
  data() {
    return {
      emojiAns: _.cloneDeep(this.selected),
    }
  },
  watch: {
    selected(newValue) {
      if (_.isEmpty(newValue)) {
        this.emojiAns = []
      }
    },

    emojiAns(newValue) {
      if (newValue.length) {
        const val = this.questionOptions[newValue]
        this.$emit('update', Object.fromEntries([[newValue, val]]))
      }
    },
  },
}
</script>

<template>
  <div class="emoji-wrapp">
    <h3 :class="$style.question">{{ questionTitle }}<sup>*</sup></h3>
    <ul :class="$style.questionOptionList">
      <li v-for="(options, key) in questionOptions" :key="key">
        <v-radio-group v-model="emojiAns">
          <v-radio
            :value="key"
            :for="options"
            :name="options"
            :class="options"
          ></v-radio>
        </v-radio-group>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.question {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
}
.question sup {
  color: #f00;
}
.questionOptionList {
  padding: 0 !important;
  margin: 0;
  list-style: none;
}
.questionOptionList li {
  float: left;
  margin: 20px 50px 8px 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #09101d;
}
.questionOptionList li:last-child {
  padding-right: 0;
  margin-right: 0;
}

@media screen and (max-width: 380px) {
  .questionOptionList {
    display: flex;
  }
  .questionOptionList li {
    flex: 33.33%;
  }
}
</style>

<style scoped>
/deep/
  .v-radio.theme--light
  .v-input--selection-controls__input
  input[type='radio'] {
  position: absolute !important;
  visibility: hidden !important;
}
/deep/
  .v-radio.theme--light
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple {
  top: -31px;
  left: -32px;
  width: 77px;
  height: 76px;
  margin: 0;
}
/deep/
  .v-radio.theme--light.Good
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple {
  background-image: url('~@assets/images/safehaven/emoji/emoticon-happy-off.svg');
}
/deep/
  .v-radio.theme--light.v-item--active.Good
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple.primary--text {
  background-image: url('~@assets/images/safehaven/emoji/Emoticon-Happy-on.svg');
}
/deep/
  .v-radio.theme--light.Ok
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple {
  background-image: url('~@assets/images/safehaven/emoji/Emoticon-JustOK-off.svg');
}
/deep/
  .v-radio.theme--light.v-item--active.Ok
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple.primary--text {
  background-image: url('~@assets/images/safehaven/emoji/Emoticon-JustOK-on.svg');
}
/deep/
  .v-radio.theme--light.Bad
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple {
  background-image: url('~@assets/images/safehaven/emoji/Emoticon-Bad-off.svg');
}
/deep/
  .v-radio.theme--light.v-item--active.Bad
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple.primary--text {
  background-image: url('~@assets/images/safehaven/emoji/Emoticon-Bad-on.svg');
}
/deep/
  .v-input--selection-controls__input:hover
  .v-input--selection-controls__ripple::before {
  background: inherit !important;
  -webkit-transition: none;
  transition: none;
  -webkit-transform: inherit !important;
  transform: inherit !important;
}
</style>
